import * as React from 'react';

// @ts-expect-error - imported from .js/.jsx file
import {FrownyIcon} from 'shells/icon/svg/frowny-icon';
// @ts-expect-error - imported from .js/.jsx file
import {SidebarIconSearchIcon} from 'shells/icon/svg/sidebar-icon-search';

import styles from './empty-view.module.css';

type Props = {
    hasQuery?: boolean;
    noResultsSubtitle: string;
    emptyActionLink?: React.ReactElement<any>;
};

export class SearchResultsEmptyView extends React.Component<Props> {
    static defaultProps = {
        noResultsSubtitle: 'No companies, people, or leads were found.',
    };

    render() {
        return this.props.hasQuery ? (
            <div className={styles['search-results-empty-view']}>
                <FrownyIcon className={styles.icon} />
                <h2 className={styles.title}>No search results.</h2>
                <h2 className={styles.subtitle}>{this.props.noResultsSubtitle}</h2>
                {this.props.emptyActionLink ? this.props.emptyActionLink : undefined}
            </div>
        ) : (
            <div className={styles['search-results-empty-view']}>
                <SidebarIconSearchIcon className={styles.icon} />
                <h2 className={styles.title}>Nothing to see… yet!</h2>
                <h2 className={styles.subtitle}>
                    As soon as you start looking around Nutshell, your recently viewed companies,
                    people, and leads will appear.
                </h2>
            </div>
        );
    }
}
